// extracted by mini-css-extract-plugin
export default {"card":"object_edit_card__WYnww","card_body":"object_edit_card_body__8V-bc","separated":"object_edit_separated__EPbEW"};